import React, { useRef } from 'react';
import styles from './index.module.scss';
import { CnBox } from '@sto/cn-ui';
/**
 * 自定义指标卡组件
 * @param content 指标卡内容
 * @param question 问题
 * @param requestId 请求ID
 * @returns 指标卡组件
 */
const CCustomMetricCard = ({ content, question, requestId }) => {
  const metricCardRef = useRef(null);

  // 如果没有有效内容，不渲染组件
  if (!content) {
    return null;
  }

  return (
    <div className={styles.metricCardBox} ref={metricCardRef}>
      <div className={styles.metricCardContent}>
        <CnBox direction="row" align="center" justify="space-between">
          <div className={styles.metricCardTitle}>
            {content?.title}
          </div>
          <div 
            className={styles.metricCardTag} 
            style={{ 
              background: content?.valueOrient === 'negative' ? '#ed0000' : '#00ad48',
            }}
          >
            {content?.tag}
          </div>
        </CnBox>
        <CnBox direction="row" align="center" className={styles.metricCardValueBox}>
          <div className={styles.metricCardValue}>
            <span className={styles.metricCardValueNum}>{content?.value}</span>
            <label className={styles.metricCardValueUnit}>{content?.unit}</label>
          </div>
          <div className={styles.customConfigsBox}>
            {content?.customConfigs?.map((item) => (
              <div className={styles.customConfigItem} key={item?.id || Math.random()}>
                <label className={styles.metricCardValueLabel}>{item?.label}</label>
                <span className={styles.metricCardValueNum}>{item?.value}</span>
                <label className={styles.metricCardValueUnit}>{item?.unit}</label>
              </div>
            ))}
          </div>
        </CnBox>
        <CnBox direction="row" align="center" className={styles.subConfigsBox} wrap="wrap" id={`subConfigsBox${requestId}`}>
          {content?.subConfigs?.map((item, index) => {
            return (
              <React.Fragment key={item?.id || Math.random()}>
                {/* 分割线: 每行的第一个没有分割线 */}
                {
                  (index !== 0) && (
                    <div className={styles.divider} style={{ opacity: 1 }}/>
                  )
                }
                <div className={styles.subConfigItem} key={item?.id || Math.random()}>
                  <label className={styles.metricCardValueLabel}>{item?.label}</label>
                  <span 
                  className={styles.metricCardValueNum}
                  style={item?.valueOrient ? { color: item?.valueOrient === 'negative' ? '#FA3C3C' : '#00AD48' } : {}}
                  >
                    {item?.value}
                  </span>
                  <label className={styles.metricCardValueUnit}>{item?.unit}</label>
                </div>
              </React.Fragment>
            )}
          )}
        </CnBox>
        <CnBox direction="row" align="center" className={styles.bottomConfigsBox}>
          {content?.bottomConfigs?.map((item) => (
            <div className={styles.bottomConfigItem} key={item?.id || Math.random()}>
              <label className={styles.metricCardValueLabel}>{item?.label}</label>
              <span className={styles.metricCardValueNum}>{item?.value}</span>
            </div>
          ))}
        </CnBox>
      </div>
    </div>
  );
};

export default CCustomMetricCard;